import type {
  AboutValues,
  ContactValues,
  EducationValues,
  ExperienceValues,
  HeroValues,
  ProjectsValues,
} from '../schemas';
import type { PortfolioSectionKind, TemplateId } from '@/types/portfolio';
import { getTemplateRenderer } from './templates';

export interface PreviewDraft {
  readonly hero?: HeroValues;
  readonly about?: AboutValues;
  readonly projects?: ProjectsValues;
  readonly experience?: ExperienceValues;
  readonly education?: EducationValues;
  readonly contact?: ContactValues;
}

interface Props {
  draft: PreviewDraft;
  enabled: ReadonlySet<PortfolioSectionKind>;
  ownerName: string;
  template?: TemplateId;
}

export function LivePreview({ draft, enabled, ownerName, template = 'minimal' }: Props) {
  const Renderer = getTemplateRenderer(template);
  return <Renderer draft={draft} enabled={enabled} ownerName={ownerName} />;
}
